import { useState, useEffect } from 'react';
import UnitCountOne from './child/UnitCountOne';
import SubscriptionPlan from './child/SubscriptionPlan';
import MostSoldStock from './child/MostSoldStock';
import MostPurchaseStock from './child/MostPurchaseStock';
import MostViewedPages from './child/MostViewedPages';
import { getDashboardData } from '../helper/Api/AdminApi';
import UserDistribution from './child/UserDistribution';
import MostUsedFeature from './child/MostUsedFeature';

const DashBoardLayerOne = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchDashboardData();
    }, []);
    

    const fetchDashboardData = async () => {
        try {
            setLoading(true);
            const response = await getDashboardData();
            if (response.Status === "success") {
                setDashboardData(response.Data);
            } else {
                setError("Failed to fetch dashboard data");
            }
        } catch (err) {
            setError("Error fetching dashboard data");
            console.error("Error fetching dashboard:", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                {error}
            </div>
        );
    }

    if (!dashboardData) {
        return (
            <div className="alert alert-warning" role="alert">
                No data available
            </div>
        );
    }
console.log("hello", dashboardData.SubscriptionPlanWiseUserCount);
    console.log("again", dashboardData.MostViewedPages);
    return (
        <>
            <UnitCountOne
                totalUsers={dashboardData.TotalAppUserCount}
                totalUsersChange={dashboardData.TotalUserVariationFromLastMonth}
                activeUserCount={dashboardData.ActiveUserCount}
                activeUserCountChange={dashboardData.ActiveUserCountVariationFromLastMonth}
                inActiveUserCount={dashboardData.InactiveUserCount}
                inActiveUserCountChange={dashboardData.InActiveUserCountVariationFromLastMonth}
                usersToday={dashboardData.UsersSignedUpToday}
                usersThisWeek={dashboardData.UsersSignedUpThisWeek}
                usersThisMonth={dashboardData.UsersSignedUpThisMonth}
                totalAssets={dashboardData.TotalAssets}
            />

            <section className="row gy-4 mt-1">
                <SubscriptionPlan
                    subscriptionData={dashboardData.SubscriptionPlanWiseUserCount}
                />

                <UserDistribution
                    platformData={dashboardData.PlatformWiseUserCount}
                />
                <MostUsedFeature
                    mostViewedPages={dashboardData.MostViewedPages}
                />
                <MostViewedPages
                    mostViewedPages={dashboardData.MostViewedPages}
                />
                <MostSoldStock
                    soldStocks={dashboardData.MostStockSold}
                />
                <MostPurchaseStock
                    purchasedStocks={dashboardData.MostStockPurchased}
                />
            </section>
        </>
    )
}

export default DashBoardLayerOne;

